export default __webpack_public_path__ + "pdfs/emotion-txt.cd706d58.pdf";